export const ANALYTICS_EVENTS = {
  // Retention-relevant
  APP_OPENED: 'app_opened',

  // Engagement (for future funnels)
  TASK_CREATED: 'task_created',
  TASK_COMPLETED: 'task_completed',
  GOAL_CREATED: 'goal_created',
  HABIT_CREATED: 'habit_created',
  HABIT_COMPLETED: 'habit_completed',
  TAB_OPENED: 'tab_opened',

  /*
    **Die Kernschleife.** Die eine Frage, die die Beta beantworten soll, ist:
    Drückt jemand den Play-Knopf ein zweites Mal? Dafür braucht es beide Enden —
    und beim Ende den Grund, weil „abgebrochen" und „erledigt" verschiedene
    Dinge über die Aufgabe sagen.

    Ohne Titel, ohne Kennung, ohne Belohnung: nur Dauer in Sekunden und Grund
    (siehe `posthog.md`, Abschnitt 3.1 — keine Inhalte).
  */
  FOCUS_STARTED: 'focus_started',
  FOCUS_ENDED: 'focus_ended',

  // Sync health
  SYNC_ERROR: 'sync_error',
} as const
